var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{on:{"click":_vm.toggleSort}},[_vm._v(" "+_vm._s(_vm.sort === "asc" ? "mdi-sort-ascending" : "mdi-sort-descending")+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }